import { apiRequest, socialApiRequest } from './apiWrapper'

export async function fetchFollowerList(
  user_id,
  follower_id,
  page = 1,
  limit = 20
) {
  const response = await socialApiRequest({
    method: 'get',
    url: '/follower/',
    params: {
      user_id,
      follower_id,
      page,
      limit
    }
  })

  if (response?.data?.followers) {
    response.data.followers = response.data.followers.map((f) => ({
      ...f,
      profile_picture: f.profile_picture || f.profile_image || f.profile_url
    }))
  }

  return response
}

export async function fetchFollowerDetails(user_id, follower_id, isUGC) {
  let response
   response = await socialApiRequest({
      method: 'post',
      url: '/follower/',
      data: { follower_id: follower_id }
    })
  // if (isUGC) {
  //   response = await socialApiRequest({
  //     method: 'post',
  //     url: '/follower/',
  //     data: { follower_id: follower_id }
  //   })
  // } else {
  //   response = await apiRequest({
  //     method: 'post',
  //     url: '/followers/',
  //     data: { user_id, follower_id }
  //   })
  // }
  return response
}

export async function fetchFollowDetails(user_id, follower_id) {
  const response = await socialApiRequest({
    method: 'get',
    url: '/follow_detail/',
    params: {
      user_id,
      follower_id
    }
  })

  if (response?.data) {
    if (response.data.followers) {
      response.data.followers = response.data.followers.map((f) => ({
        ...f,
        profile_picture: f.profile_picture || f.profile_image || f.profile_url
      }))
    }
    if (response.data.following) {
      response.data.following = response.data.following.map((f) => ({
        ...f,
        profile_picture: f.profile_picture || f.profile_image || f.profile_url
      }))
    }
  }

  return response
}

export async function unfollowUser(user_id, follower_id, isUGC) {
  let response
  response = await socialApiRequest({
      method: 'delete',
      url: `/follower/`,
      data: { follower_id: follower_id }
    })
  // if (isUGC) {
  //   response = await socialApiRequest({
  //     method: 'delete',
  //     url: `/follower/`,
  //     data: { follower_id: user_id }
  //   })
  // } else {
  //   response = await apiRequest({
  //     method: 'delete',
  //     url: '/followers/',
  //     data: { user_id, follower_id }
  //   })
  // }
  return response
}

export async function fetchSuggestedUsers({ limit = 20, source_limit = 30, user_id = null } = {}) {
  const params = { limit, source_limit }

  // Do not send user_id or country in query params as per new API contract.
  const headers = user_id ? { 'x-user-id': user_id } : undefined

  const response = await socialApiRequest({
    method: 'get',
    url: '/suggested_users/',
    params,
    headers
  })

  // normalize profile picture field if present inside elements
  if (response?.data && Array.isArray(response.data)) {
    response.data = response.data.map((u) => ({
      ...u,
      profile_picture: u.profile_picture || u.profile_image || u.profile_url
    }))
  }

  return response
}
